import React from 'react'
import CurrentUser from 'components/CurrentUser'
import noop from 'utils/noop'

const Feature = ({ children, name, render, fallback }) => (
  <CurrentUser
    render={currentUser => {
      const features = currentUser && currentUser.features
      const enabled = Array.isArray(features) && features.includes(name)

      if (typeof children === 'function') {
        return children(enabled)
      }

      return enabled ? render() : fallback()
    }}
  />
)

Feature.defaultProps = {
  fallback: noop,
  render: noop
}

export default Feature



// WEBPACK FOOTER //
// ./src/components/Feature.js